/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import {
  defaultStudyOrderDetailsResponse,
  IDiagnosticReport,
  IErrorMessage,
  ISeriesDetail,
  IStudyOrderResponse,
  IStudyOrderDetailsResponse,
  PaginationResponse,
  SlicePaginationResponse,
  initSlicePageable,
} from "@advapacs/common";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  studies: [] as IStudyOrderResponse[],
  pageableStudy: initSlicePageable,
  studyOrOrderDetails: null as IStudyOrderDetailsResponse,
  errorMessage: null as IErrorMessage,
  reportDetail: null as IDiagnosticReport,
  allSeries: [] as Array<ISeriesDetail>,
};

const ExamsSlice = createSlice({
  name: "examsReducer",
  initialState,
  reducers: {
    getStudiesStart(state) {
      state.loading = true;
    },
    getStudiesSuccess(
      state,
      action: PayloadAction<SlicePaginationResponse<IStudyOrderResponse>>
    ) {
      const { content, pageable } = action.payload;
      state.loading = false;
      state.studies = content;
      state.pageableStudy = pageable;
    },
    getStudiesFail(state, action: PayloadAction<IErrorMessage>) {
      state.loading = false;
      state.errorMessage = action.payload;
    },
    getReportStart(state) {
      state.loading = true;
    },
    getReportSuccess(state, action) {
      state.loading = false;
      state.reportDetail = action.payload;
    },
    getReportFail(state) {
      state.loading = false;
    },
    getReportContentSuccess(state) {
      state.loading = false;
    },
    getStudyOrOrderDetailStart(state) {
      state.studyOrOrderDetails = defaultStudyOrderDetailsResponse;
      state.loading = true;
    },
    getStudyOrOrderDetailSuccess(
      state,
      action: PayloadAction<IStudyOrderDetailsResponse>
    ) {
      state.studyOrOrderDetails = action.payload;
      state.loading = false;
    },
    getStudyOrOrderDetailFail(state) {
      state.loading = false;
    },
    getAllSeriesStart(state) {
      state.loading = true;
      state.allSeries = null;
    },
    getAllSeriesSuccess(
      state,
      action: PayloadAction<PaginationResponse<ISeriesDetail>>
    ) {
      const { content } = action.payload;
      state.allSeries = content;
      state.loading = false;
    },
    getAllSeriesFail(state) {
      state.loading = false;
    },

    clearData: () => initialState,
  },
});

export const ExamActions = ExamsSlice.actions;
export default ExamsSlice.reducer;
